/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse2003ApplicationsStatus
 */
export interface InlineResponse2003ApplicationsStatus {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003ApplicationsStatus
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003ApplicationsStatus
     */
    applied?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003ApplicationsStatus
     */
    accepted?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003ApplicationsStatus
     */
    discarded?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003ApplicationsStatus
     */
    selected?: number;
}

export function InlineResponse2003ApplicationsStatusFromJSON(json: any): InlineResponse2003ApplicationsStatus {
    return InlineResponse2003ApplicationsStatusFromJSONTyped(json, false);
}

export function InlineResponse2003ApplicationsStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2003ApplicationsStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'applied': !exists(json, 'applied') ? undefined : json['applied'],
        'accepted': !exists(json, 'accepted') ? undefined : json['accepted'],
        'discarded': !exists(json, 'discarded') ? undefined : json['discarded'],
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
    };
}

export function InlineResponse2003ApplicationsStatusToJSON(value?: InlineResponse2003ApplicationsStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'applied': value.applied,
        'accepted': value.accepted,
        'discarded': value.discarded,
        'selected': value.selected,
    };
}


